import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  deepPurpleMui,
  greyMui,
  MOBILE_BREAKPOINT,
  rydeColors,
  ScreenDepth,
} from "@ryde/theme";

export const BulkActionsPanelStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-actions-panel",
})`
  /* Both drawer shells pad the content inline-start; bleed back over it so the rows span
     the full drawer width. */
  width: calc(100% + 24px);
  margin-inline-start: -24px;
  display: flex;
  flex-direction: column;
  text-align: start;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: calc(100% + 10px);
    margin-inline-start: -10px;
  }

  .bulk-actions-search {
    position: sticky;
    top: 0;
    z-index: ${ScreenDepth.HEADER_FORM_CONTROLS};
    padding-inline: 16px;
    padding-block: 10px;
    border-bottom: 1px solid ${greyMui._200};
    background-color: ${rydeColors.white};
  }

  .bulk-actions-list {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding-block: 4px;
    padding-inline: 0;
    list-style: none;
  }

  .bulk-actions-empty {
    margin: 16px;
    color: ${blueGreyMui._400};
    font-size: 14px;
  }

  .bulk-action-item {
    display: flex;
    align-items: center;
    gap: 4px;
    padding-inline-end: 16px;
    border-inline-start: 3px solid transparent;
    transition:
      background-color 0.15s ease,
      border-color 0.15s ease;

    &:hover {
      background-color: ${greyMui._100};
      border-inline-start-color: ${deepPurpleMui.A400};
    }

    &:hover .bulk-action-arrow {
      opacity: 1;
    }
  }

  .bulk-action-row {
    display: flex;
    flex-grow: 1;
    align-items: center;
    gap: 12px;
    min-height: 44px;
    padding-inline: 22px 8px;
    border: none;
    background-color: transparent;
    color: ${greyMui._900};
    font-size: 16px;
    text-align: start;
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid ${deepPurpleMui.A400};
      outline-offset: -2px;
    }

    &:disabled {
      color: ${greyMui._500};
      cursor: not-allowed;
    }
  }

  .bulk-action-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    color: ${blueGreyMui._500};

    svg {
      width: 18px;
      height: 18px;
    }

    /* The icon set mixes hard-coded fills and strokes, and some icons are drawn white
       for dark backgrounds (cancel) - force a single neutral tone so every icon shows
       up and the whole column reads as one icon family. */
    svg [fill]:not([fill="none"]) {
      fill: currentColor;
    }

    svg [stroke]:not([stroke="none"]) {
      stroke: currentColor;
    }
  }

  .bulk-action-label {
    flex-grow: 1;
  }

  .bulk-action-arrow {
    flex-shrink: 0;
    opacity: 0;
    color: ${deepPurpleMui.A400};
    transition: opacity 0.15s ease;
  }

  .bulk-action-hint {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;

    svg {
      font-size: 18px;
      cursor: help;
    }

    /* The hint only opens on hover, so it has no job on touch devices. */
    @media (max-width: ${MOBILE_BREAKPOINT}) {
      display: none;
    }
  }
`;
